import * as React from "react";
import { gql, useQuery } from "@apollo/client";

import {
  Transaction,
  ViewTransactionQueryQuery,
  ViewTransactionQueryQueryVariables
} from "../../../schemaTypes";

export const viewTransactionQuery = gql`
  query ViewTransactionQuery($id: String!) {
    viewTransaction(id: $id) {
      id
      amount
      transferTypes
      charge
      reference
      type
      status
      currency
      offer{
        id
        title
        description
        bannerUrl
        category {
          id
          name
          imgSrc
          createdBy{
            id
            role
          }
          createdAt
          updatedAt
        }
        offerType
        discountType
        discountValue
        partnerVoucher
        referralUrl
        status
        usageLimitPerUser
        totalUsageLimit
        startDate
        endDate
        community{
          id
          name
          alias
        }
        location{
          id
          city
        }
        redemptions
        revenueGenerated
        clickThroughs
        featured
        createdBy{
          id
          admin {
            id
            merchantProfile {
              id
              companyName
              logoUrl
            }
          }
        }
        offerTOR
        createdAt
        updatedAt
      }
      njoyCode
      partnerVoucher
      partnerVoucher
      user{
        id
        customer {
          firstname
          lastname
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export interface WithViewTransaction {
  transaction: Transaction | null;
  loading: boolean;
}

interface Props {
  transactionId: string;
  children: (data: WithViewTransaction) => React.ReactElement | null;
}

export const ViewTransaction: React.FC<Props> = ({ children, transactionId }) => {
  const { data, loading } = useQuery<
    ViewTransactionQueryQuery,
    ViewTransactionQueryQueryVariables
  >(viewTransactionQuery, {
    variables: { id: transactionId },
    fetchPolicy: "cache-first"
  });

  let transaction: Transaction | null = null;
  if (data && data.viewTransaction) {
    transaction = data.viewTransaction as Transaction;
  }

  return children({
    transaction,
    loading
  });
};